import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack, MdModeEdit, MdAutorenew } from "react-icons/md";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { cardTypeActions } from "./actions/cardstypes.actions";

import { Spinner, Placeholder } from "../Shared";
import { routeConstants } from "../../_constants";

export class CardType extends Component {
  componentDidMount() {
    this.getCardType();
  }

  componentWillUnmount() {
    this.props.resetCardType();
  }

  getCardType = () => {
    const { match } = this.props;
    if (match.params && match.params.id) {
      this.props.getCardType(match.params.id);
    }
  };

  render() {
    const { match, response, fetching, error } = this.props;
    const cardType = response && response.modelList[0];

    return (
      <div>
        <Row>
          <Col sm="6">
            <Link
              className="btn btn-outline btn-primary"
              to={routeConstants.CARDTYPES.path}
            >
              <MdArrowBack /> Back to list
            </Link>
          </Col>
          <Col sm="6">
            <div className="text-right">
              <h5 className="item-count">
                <div>
                  Card Type: {cardType && cardType.code}{" "}
                  <Button
                    onClick={this.getCardType}
                    color="primary"
                    outline
                    disabled={fetching}
                  >
                    {fetching ? (
                      <Spinner />
                    ) : (
                      <div>
                        <MdAutorenew size={20} />
                      </div>
                    )}
                  </Button>
                </div>
              </h5>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            {error && (
              <Alert color="danger">
                <strong>Error:</strong> {error.message}
              </Alert>
            )}

            <dl className="row">
              {/* <dt className="col-sm-3">Card Type Id</dt>
              <dd className="col-sm-9">
                {cardType ? (
                  cardType.id
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd> */}

              <dt className="col-sm-3">Card Type Code</dt>
              <dd className="col-sm-9">
                {cardType ? (
                  cardType.code
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>

              <dt className="col-sm-3">Card Type Description</dt>
              <dd className="col-sm-9">
                {cardType ? (
                  cardType.description
                ) : (
                  <Placeholder text="Fetching data" blur={3} />
                )}
              </dd>
            </dl>
            <Link
              className="btn btn-primary"
              to={`${routeConstants.CARDTYPES.path}/edit/${match.params.id}`}
            >
              <MdModeEdit /> Edit
            </Link>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, request, response, error } = state.viewCardType;
  return {
    fetching,
    fetched,
    request,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCardType: bindActionCreators(cardTypeActions.getCardType, dispatch),
    resetCardType: bindActionCreators(cardTypeActions.resetCardType, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CardType);
